import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'dashv2';
  currentDate = new Date();
  docs = "docs";
  emprunts = "emprunts";
  mails = "mails";
  izly = "izly";
  papercut = "papercut";
  contact = "contact";

  etatMode() {
    var checkbox = (<HTMLInputElement>document.querySelector('input[type="checkbox"]'));

    checkbox.addEventListener('change', function () {
      var elements = document.getElementsByClassName("modeJN"), i, len;
      var fond = document.getElementById("fond");
      var fond2 = document.getElementById("fond2");
      var divdemerde = document.getElementsByClassName("ui-datepicker");
      var li = document.getElementsByTagName('li');
      console.log(fond);
      if (checkbox.checked) {
        document.body.style.background = "black";
        for (i = 0, len = elements.length; i < len; i++) {
          (<HTMLElement>elements[i]).style.color = "white";
        }
        if (fond != null) {
          fond.style.background = "black";
        }
        if (fond2 != null) {
          fond2.style.background = "black";
        }
        for (i = 0, len = divdemerde.length; i < len; i++) {
          (<HTMLElement>divdemerde[i]).style.background = "black";
          (<HTMLElement>divdemerde[i]).style.border = "black";
        }
        for (i = 0, len = li.length; i < len; i++) {
          (<HTMLElement>li[i]).style.backgroundColor = "#b9bfbf";
          (<HTMLElement>li[i]).style.color = "white";
        }
        console.log('Checked');

      } else {
        document.body.style.background = "white";
        for (i = 0, len = elements.length; i < len; i++) {
         (<HTMLElement> elements[i]).style.color = "black";
        }
        if (fond != null) {
          fond.style.background = "white";
        }
        if (fond2 != null) {
          fond2.style.background = "white";
        }
        for (i = 0, len = divdemerde.length; i < len; i++) {
          (<HTMLElement>divdemerde[i]).style.background = "white";
          (<HTMLElement> divdemerde[i]).style.border = "white";
        }
        for (i = 0, len = li.length; i < len; i++) {
          (<HTMLElement>li[i]).style.backgroundColor = "white";
          (<HTMLElement> li[i]).style.color = "black";
        }
        console.log('Not checked');
      }
    });
  } ;
}
